const initialState = {
	data: [],
	total: 0,
	params: {},
	selected: {},
	sidebarOpen: false,
	sidebarStatus: 'add',
}

const history = (state = initialState, action) => {
	switch (action.type) {
		case 'PLAYERHISTORY_GET_DATA':
			return {
				...state,
				data: action.data,
				total: action.total,
				params: action.params,
			}
		case 'PLAYERHISTORY_DEL_DATA':
			const data = state.data.filter((e) => e.id !== action.index)
			return { ...state, data, total: state.total - 1 }
		case 'PLAYERHISTORY_ADD_DATA':
			const addData = [...state.data, action.data]
			return Object.assign({ ...state, data: addData, total: state.total + 1 })
		case 'PLAYERHISTORY_UPDATE_DATA':
			const index = state.data.findIndex((e) => e.id === action.index)
			const upateData = state.data
			upateData[index] = action.data
			return Object.assign({ ...state, data: [...upateData] })
		case 'PLAYERHISTORY_GET_CURRENT':
			return { ...state, selected: action.selected }
		case 'PLAYERHISTORY_SET_SIDEBAR':
			return {
				...state,
				sidebarStatus: action.status,
				sidebarOpen: !state.sidebarOpen,
			}
		default:
			return { ...state }
	}
}

export default history
